export default {"src":"/_next/static/media/arrow-down-icon.1f1d8a9d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};